module.exports = __webpack_public_path__ + "files/2f17aee3fca78ee454c83226bca19add.svg";